export default __webpack_public_path__ + "static/media/background-6.2417ec4f.jpg";